import styles from './singleProperty.module.css';
import buttons from 'components/_styled/buttons.module.css';
import Link from "next/link";

const ListSingleUnitBox = ({ button }) => {
    return <div className={styles.InfoBox}>
        <div className={styles.BlurbContainer}>
            <h1 className={styles.InfoBoxTitle}>List a single property</h1>
            <p className={styles.InfoBoxDescription}>
                We offer our specialist listing services for you to market a single property at one low cost for the year. 
                Reach over 1.6 million visitors at an affordable cost with Completely Retail.
            </p>
        </div>
        <div className={styles.PriceContainer}>
            <div className={styles.Tag}>One time payment<br/>for one year</div>
            <h2><div><span>£</span>1</div>50<span>+ VAT</span></h2>  {/* NB: <div> fixes odd spacing between 1 & 5 */}

            {button &&
                <Link prefetch={false} href="/sales/single-property" passHref>
                    <a className={buttons.primaryButton}>
                        Buy now
                    </a>
                </Link>
            }

        </div>
    </div>
}

export default ListSingleUnitBox;